import { Tenant } from 'state/tenant';
import { Theme as MUITheme } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';

import { QueryParameters } from 'hooks/useQueryParameters';

export interface Theme {
  mui: MUITheme;

  shape: {
    borderRadiusSmall: number;
    borderRadiusLarge: number;
  };

  embedded: boolean;
}

export default (tenant: Tenant, queryParams: QueryParameters): Theme => {
  const muiTheme = createMuiTheme({
    palette: {
      primary: {
        main: tenant.brandColor,
      },
      secondary: {
        main: tenant.brandColor,
      },
      tonalOffset: 0.65,
      error: {
        main: '#E82117',
      },
      action: {
        disabledBackground: fade(tenant.brandColor, 0.3),
        disabled: 'white',
      },
    },
    typography: {
      fontSize: 14,
      htmlFontSize: 10,
      fontFamily: 'Poppins, sans-serif;',
    },
  });

  return {
    mui: muiTheme,

    shape: {
      borderRadiusSmall: muiTheme.shape.borderRadius,
      borderRadiusLarge: muiTheme.shape.borderRadius * 6,
    },

    embedded: queryParams.embedded,
  };
};
